<template>
  <SOSlotBase>
    <template v-slot:title-bar>
      <SOTitleBar page-title="Tambah Mesin Baru" type="back" @back="back" />
    </template>
    <template v-slot:content>
      <div class="content-wrapper f-regular f-14 d-block">
        <span class="f-c-midgrey">ID Device: </span
        ><span class="f-c-black">{{ input.id }}</span>
      </div>
      <div class="content-wrapper">
        <div class="wrapper-input">
          <SOInputRegular
            title="Serial Number"
            :required="true"
            action-text="Scan QR Code"
            id="input-serial"
            :icon="true"
            :uppercase="true"
            v-model="input.serial"
            @input="input.serial"
            @action="toScanSerial"
          />
          <ErrorMessage label="Serial Number" :validation="$v.input.serial" />
        </div>
        <div class="wrapper-input">
          <SOInputRegular
            title="Nama Mesin"
            :required="true"
            placeholder="Clean Laundry"
            v-model="input.nama"
            @input="input.nama"
          />
          <ErrorMessage label="Nama Mesin" :validation="$v.input.nama" />
        </div>
        <div class="wrapper-input">
          <label class="form-label require"> Jenis Mesin </label>
          <SOInputRadioBig
            :radio-group="radioJenis"
            :radio-selected="input.jenis"
            @selected-radio="
              (val) => {
                input.jenis = parseInt(val);
              }
            "
          />
        </div>
        <div class="wrapper-input">
          <label class="form-label require" v-if="input.jenis === 1"> Sensor Pintu </label>
          <label class="form-label require" v-if="input.jenis === 2"> Sensor Kelembapan </label>
          <SOInputRadioBig
            :radio-group="radioSensor"
            :radio-selected="input.door"
            @selected-radio="
              (val) => {
                input.door = parseInt(val);
              }
            "
          />
        </div>
        <div class="wrapper-input">
          <SOInputSelectMultiple
            title="Kategori Mesin"
            :label="'title'"
            :track-by="'value'"
            :searchable="true"
            :taggable="true"
            :multiple="false"
            :options="tag"
            :value="kategoriMesin"
            @selected="selectedTagMesin"
          />
          <ErrorMessage
            label="Kategori Mesin"
            :validation="$v.input.kategori"
          />
          <div class="f-c-midgrey f-12 f-regular m-t-8">
            Mesin dapat digunakan untuk layanan yang terhubung dengan kategori
            yang sama.
          </div>
        </div>
        <SOButton
          text="Tambahkan"
          :full="true"
          :primary="true"
          :disable="false"
          :loading="pageSetting.loading"
          @action="addMesin"
        />
      </div>
    </template>
    <template v-slot:modal>
      <SnapMesinModalInsertBerhasil
        v-if="pageSetting.modal"
        :nama-mesin="input.nama"
        :qr="qr"
        @back="toList"
      />
    </template>
  </SOSlotBase>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOInputRadioBig from "@/so-components/global/input/SOInputRadioBig";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import { mapGetters } from "vuex";
import SOButton from "@/so-components/global/ui/SOButton";
import SnapMesinModalInsertBerhasil from "@/modules/outlet/mesin/views/modal/SnapMesinModalInsertBerhasil";
import SOInputScan from "@/so-components/global/input/SOInputScan";
import { minLength, required } from "vuelidate/lib/validators";
import ErrorMessage from "@/component-items/ErrorMessage";
import SOInputSelectMultiple from "@/so-components/global/input/SOInputSelectMultiple";

export default {
  name: "SnapMesinTambah",
  components: {
    SOInputSelectMultiple,
    ErrorMessage,
    SOInputScan,
    SnapMesinModalInsertBerhasil,
    SOButton,
    SOInputSelect,
    SOInputRadioBig,
    SOInputRegular,
    SOTitleBar,
    SOSlotBase,
  },
  data() {
    return {
      pageSetting: {
        loading: false,
        modal: false,
      },

      qr: "",
      idoutlet: "",
      idmesin: "",
      tag: [],
      kategoriMesin: [],
      radioJenis: [
        {
          title: "Mesin Cuci",
          name: "jenis-mesin",
          value: "1",
          id: "mc",
        },
        {
          title: "Mesin Pengering",
          name: "jenis-mesin",
          value: "2",
          id: "mp",
        },
      ],
      radioSensor: [
        {
          title: "Ada",
          name: "sensor",
          value: "1",
          id: "sa",
        },
        {
          title: "Tidak Ada",
          name: "sensor",
          value: "0",
          id: "st",
        },
      ],
    };
  },
  validations: {
    input: {
      serial: {
        required,
        minLength: minLength(4),
      },
      nama: {
        required,
        minLength: minLength(2),
      },
      jenis: {
        required,
      },
      door: {
        required,
      },
      tag: {
        required,
      },
    },
  },
  methods: {
    back() {
      this.$router.push({
        name: "SnapMesinScanId",
        params: {
          idoutlet: this.$route.params.idoutlet,
        },
      });
    },

    toList() {
      this.$store.commit("snapMesinModule/resetDataCreateMesin");
      $("#modal-insert-berhasil").modal("hide");
      setTimeout(() => {
        this.$router.push({
          name: "ListSnapMesin",
          query: {
            idoutlet: this.$route.params.idoutlet,
          },
        });
      }, 500);
    },

    toScanSerial() {
      this.$router.push({
        name: "SnapMesinScanSerial",
        params: {
          idoutlet: this.$route.params.idoutlet,
        },
      });
    },

    async tagMesin() {
      const res = await this.$store.dispatch(
        "snapMesinModule/fetchTagMesin",
        this.$route.params.idoutlet
      );
      if (res.success) {
        this.listTagMesin.data.forEach((tagmesin) => {
          this.tag = [
            ...this.tag,
            {
              id: tagmesin.id,
              title: tagmesin.nama,
              value: tagmesin.nama,
            },
          ];
        });
      } else {
        this.$toast.error(res.err);
      }
    },

    validateError() {
      this.$v.input.serial.$touch();
      this.$v.input.nama.$touch();
      this.$v.input.jenis.$touch();
      this.$v.input.door.$touch();
      this.$v.input.tag.$touch();
      return (
        this.$v.input.serial.$invalid ||
        this.$v.input.nama.$invalid ||
        this.$v.input.jenis.$invalid ||
        this.$v.input.door.$invalid ||
        this.$v.input.tag.$invalid
      );
    },

    async addMesin() {
      if (this.validateError()) {
        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
        return;
      }

      console.log(this.input.tag);

      let payload = {
        id: this.input.id,
        serial: this.input.serial,
        id_outlet: this.idoutlet,
        nama: this.input.nama,
        jenis: this.input.jenis,
        door: this.input.door,
        nama_snap_tag: "",
      };

      if (this.input.tag.title !== undefined) {
        payload.nama_snap_tag = this.input.tag.title;
      } else {
        payload.nama_snap_tag = this.input.tag[0].title;
      }

      // console.log(payload);
      this.pageSetting.loading = true;
      const res = await this.$store.dispatch(
        "snapMesinModule/tambahMesin",
        payload
      );
      this.pageSetting.loading = false;
      if (!res.success) {
        this.$toast.error(res.err);
      } else {
        this.qr = res.data.qr;
        this.pageSetting.modal = true;
      }
    },

    selectedTagMesin(val) {
      this.kategoriMesin = val;
      this.input.tag = val;
    },
  },
  async mounted() {
    await this.tagMesin();
    this.idmesin = this.$route.params.idmesin;
    this.idoutlet = this.$route.params.idoutlet;
  },
  computed: {
    ...mapGetters("snapMesinModule", {
      listTagMesin: "getListTagMesin",
      input: "getDataCreateMesin",
    }),
  },
};
</script>

<style scoped>
.content-wrapper {
  padding: 12px 20px;
  border-top: 1px solid #e0e0e0;
}

.wrapper-input:not(:nth-child(1)) {
  margin-top: 16px;
}
</style>